import { Input } from '@nerdwallet/currency';
import {
  stringInputSpec,
  boolCheckboxSpec,
  stringSelectSpec,
} from '~/app/lib/editing-configs';
import { get } from 'lodash';
import classNames from 'classnames';
import UniversalContainer, {
  UniversalContainerProps,
} from '../universal-container';
import styles from './input-button.module.scss';
import { useInputButton } from './use-input-button';

const FIELD_TYPES = {
  ZIP_CODE: 'zipCode',
  PHONE_NUMBER: 'phoneNumber',
};

interface InputButtonProps {
  container: UniversalContainerProps;
  appendQueryParamToUrl: boolean;
  paramName: string;
  fieldType: string;
  placeHolder: string;
}

const InputButton = ({
  container,
  appendQueryParamToUrl,
  paramName,
  fieldType = FIELD_TYPES.ZIP_CODE,
  placeHolder,
}: InputButtonProps) => {
  const { error, handleChange, inputValue } = useInputButton({
    fieldType,
    appendQueryParamToUrl,
    paramName,
  });

  return (
    <div>
      <UniversalContainer {...container}>
        <Input
          placeholder={placeHolder}
          onBlur={handleChange}
          type="text"
          onChange={handleChange}
          value={inputValue}
          className={classNames(styles.input, { [styles.error]: error })}
        />
      </UniversalContainer>
    </div>
  );
};

InputButton.getEditingConfig = (componentDocument: any, fieldName: string) => {
  const paramNameInputConfig = get(
    componentDocument.props,
    `${fieldName}.appendQueryParamToUrl`,
    false
  )
    ? [stringInputSpec('inputButton.paramName', 'Param Name')]
    : [];

  return [
    ...UniversalContainer.getEditingConfig(
      componentDocument,
      'Container',
      [
        'backgroundColor',
        'backgroundImage',
        'border',
        'margin',
        'padding',
        'hide',
        'jumpLinkId',
        'width',
      ],
      `${fieldName}.container`
    ),
    stringSelectSpec(
      'inputButton.fieldType',
      'Embed Type',
      [
        { label: 'Zip Code', value: 'zipCode' },
        { label: 'Phone Number', value: 'phoneNumber' },
      ],
      {
        help: 'Defaults to "zipCode"',
      }
    ),
    boolCheckboxSpec(
      'inputButton.appendQueryParamToUrl',
      'Append Query Param To Url'
    ),
    ...paramNameInputConfig,
    stringInputSpec('inputButton.placeHolder', 'Placeholder'),
  ];
};

export default InputButton;
